import config from "../../../../config"
import isDefaultExpanded from "./isDefaultExpanded"

const calculateInitialExpansion = (location,treeData,rawData) => {
  const pathName = location.pathname.replace(config.gatsby.pathPrefix,'');
  //if the default value is to expand all items
  if(!config.sidebar.startCollapsed){
    const expandedRetval = {}
    rawData.forEach(data => {
      expandedRetval[data.node.fields.slug] = true
    });
    return expandedRetval
  }

  //is the sidebar is not expanded by default
  let initialExpansion = {}
  const findDefaultExpanded = (node,foundNodes) => {
    if(node.expansionSettings?.defaultExpandedFrom || node.expansionSettings?.defaultExpandedTo){
      if(isDefaultExpanded(pathName,node.expansionSettings))
        foundNodes.push(node)
    }
    (node.items??[]).forEach(n => findDefaultExpanded(n,foundNodes))
  }

  const constructExpansionsFromUrl = (url) => {
    const expansions = {}
    const pathSplit = url.split('/').filter(i => i)
    pathSplit.forEach((p, i) => {
      expansions["/"+pathSplit.slice(0,i+1).join("/")] = true
    })
    return expansions;
  }

  const foundNodes = []
  if(pathName == "/"){
    (treeData.items ?? []).forEach(node => {
      findDefaultExpanded(node,foundNodes);
    });
    foundNodes.forEach(x => {
      initialExpansion = Object.assign(initialExpansion,constructExpansionsFromUrl(x.url))
    })
  }
  else{
    const fromPathName = constructExpansionsFromUrl(pathName)
    initialExpansion = Object.assign(initialExpansion,fromPathName)
  }
  return initialExpansion
}


export default calculateInitialExpansion